import * as jwtDecode from 'jwt-decode'
import RestClient from './RestClient'
import { signinSuccess, signoutSuccess } from '../actions'

const AUTH_TOKEN = 'AUTH_TOKEN'
const ENTRY_POINT = 'auth/'
export default class AuthService {
  restClient: RestClient

  constructor(restClient: RestClient) {
    this.restClient = restClient
  }

  builtinSignin(loginInfo: ILoginInfo) {
    return this.restClient
      .post(ENTRY_POINT + 'builtin-signin', loginInfo)
      .then(response => this.getAuthInfo(response.accessToken))
      .then(() => this.restClient.dispatch(signinSuccess()))
  }

  soLoginPage() {
    return this.restClient
      .get(ENTRY_POINT + 'so-login-page')
  }

  soSignin(accessToken: string) {
    return this.restClient
      .post(ENTRY_POINT + 'so-signin', accessToken)
      .then(response => this.getAuthInfo(response.accessToken))
      .then(() => this.restClient.dispatch(signinSuccess()))
  }

  signout() {
    return this.restClient.post(ENTRY_POINT + 'signout')
      .then(authInfo => this.restClient.dispatch(signoutSuccess()))
  }

  register(registerInfo: IRegisterInfo): Promise<IUser> {
    return this.restClient.post(ENTRY_POINT + 'register', registerInfo)
  }

  confirmRegister(code: string): Promise<IUser> {
    return this.restClient.post(ENTRY_POINT + 'confirm-register', undefined, {code: code})
  }

  getAuthInfo(token: string): string {
    let jwt: any
    try {
      jwt = jwtDecode(token)
    } catch (e) {
      jwt = {}
    }

    return jwt.sub
  }

  getAuthInfoFromCache(): string {
    const token = this.getAuthToken(AUTH_TOKEN)
    return this.getAuthInfo(token)
  }

  getAuthToken(name: string) {
    if (document.cookie.length > 0) {
      let start = document.cookie.indexOf(name + '=')
      if (start !== -1) {
        start = start + name.length + 1
        let end = document.cookie.indexOf(';', start)
        if (end === -1) {
          end = document.cookie.length
        }
        return unescape(document.cookie.substring(start, end))
      }
    }
    return ''
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/services/AuthService.ts